import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'portals-duration-picker',
	templateUrl: './duration-picker.component.html',
	styleUrls: ['./duration-picker.component.scss'],
})
export class DurationPickerComponent {
	@Input() isRange: boolean = false;
	@Input() value: number = 0; // seconds count
	@Input() rangeValue: number[] = [0, 0]; // array of seconds
	@Output() onValueChange = new EventEmitter<{
		value: number | number[];
		isRange: boolean;
	}>();

	formatSecondsToHhMm(seconds: number): string {
		const hhMm = new Date(seconds * 1000).toISOString().substring(11, 16);
		return hhMm;
	}

	convertHhMmToSeconds(value: string): number {
		const values: string[] = value.split(':');
		const hours: number = +values[0];
		const minutes: number = +values[1];
		const seconds = hours * 60 * 60 + minutes * 60;

		return seconds;
	}

	onTimeChangedChange(value: string, isEnd: boolean = false): void {
		const newValue = this.convertHhMmToSeconds(value);
		let newRangeValue = [...this.rangeValue];

		if (this.isRange) {
			newRangeValue = !isEnd ? [newValue, newRangeValue[1]] : [newRangeValue[0], newValue];
			this.rangeValue = newRangeValue;
			this.onValueChange.emit({
				value: this.rangeValue,
				isRange: this.isRange,
			});
		} else {
			this.value = newValue;
			this.onValueChange.emit({
				value: this.value,
				isRange: this.isRange,
			});
		}
	}
}
